import "./About.scss"
import React, { useEffect, useState } from "react"
import Container from "../../../components/ui/Container.js"
import Game from "./Game"
import useAboutSong from "./useAboutSong"
import { SoundOff, SoundOn } from "./icons"
import { api } from "../../../services/api"
import useFetch from "../../../hooks/useFetch"
import { Character } from "./Character"
import { ModalGanaste } from "../../../components/games/ModalGanaste"
import { EasterEgg } from "../../../components/about/EasterEgg"
import { useTranslation, Trans } from "react-i18next"

const funWithWords = "Fun with Words"
const maxVisibleContributors = funWithWords
  .split("")
  .filter((letter) => letter !== " ").length
const rows = funWithWords.split(" ").map((word, wordIndex, words) => {
  const consumedLetters = words.reduce(
    (acc, current, index) => (index < wordIndex ? acc + current.length : acc),
    0
  )
  return word.split("").map((letter, letterIndex) => {
    const globalIndex = consumedLetters + letterIndex
    return {
      letter,
      id: globalIndex,
    }
  })
})

const Acerca = () => {
  const { isPlaying, play, stop, wasMusicDisabled } = useAboutSong()
  const [selectedContributorId, setSelectedContributorId] = React.useState(null)
  const [dones, setDones] = React.useState([])
  const showModalGanaste = useState(false)
  const { url, opt } = React.useMemo(
    () =>
      api.contributors.readAll({
        limit: maxVisibleContributors,
        randomized: true,
      }),
    []
  )

  const [data, isPending, error] = useFetch({ url, opt })

  useEffect(() => {
    return () => stop()
    // eslint-disable-next-line
  }, [])

  const [easter, setEaster] = useState(false)
  const [about, setAbout] = useState(true)

  const showEaster = () => {
    // setEaster
    setAbout(false)
    window.scrollTo(0, 0)
    setTimeout(() => setEaster(true), 1000)
  }

  const { t } = useTranslation()

  return (
    <>
      <Container section="about">
        <EasterEgg showEaster={showEaster} playMusic={play} />
        <ModalGanaste show={showModalGanaste} steps={false} />

        <div className="d-flex flex-column flex-lg-row">
          <div
            style={{ display: easter ? "none" : "block" }}
            className={"about-header " + (about ? "" : "hidden")}
          >
            <h1>{t(`about.title`)}</h1>

            {t("about.body", { returnObjects: true }).map((item) => (
              <p>
                <Trans
                  i18nKey={item}
                  components={{ italic: <i />, bold: <strong /> }}
                />
              </p>
            ))}
          </div>
          {error ? (
            <p>{t(`about.error`)}</p>
          ) : easter ? (
            <div className="d-flex align-items-start justify-content-center flex-grow-1">
              <div
                className="d-flex gap-2 flex-row flex-sm-column align-items-start align-items-sm-center position-relative"
                style={{
                  minHeight: 0,
                }}
              >
                {rows.map((row, rowIndex) => (
                  <div
                    key={rowIndex}
                    className="d-flex flex-column flex-sm-row"
                  >
                    {row.map(({ id, letter }) => {
                      const name = isPending ? "" : data[id].name
                      return (
                        <React.Fragment key={id}>
                          <Character
                            letter={letter}
                            done={dones.includes(id)}
                            name={name}
                            onSelect={() => {
                              if (dones.includes(id)) return
                              // Don't annoy users playing music when they disabled it
                              if (!wasMusicDisabled && !isPlaying) {
                                play()
                              }
                              setSelectedContributorId(id)
                            }}
                            selected={selectedContributorId === id}
                            colors={data?.[id]?.colors}
                          />
                          {selectedContributorId === id ? (
                            <Game
                              onCancel={() => setSelectedContributorId(null)}
                              onCompleted={() => {
                                setDones((c) => [...c, id])
                                const over = dones.length + 1 === data.length
                                showModalGanaste[1](over)
                                setSelectedContributorId(null)
                              }}
                              name={name}
                              letter={letter.toUpperCase()}
                              colors={data?.[id]?.colors}
                            />
                          ) : null}
                        </React.Fragment>
                      )
                    })}
                  </div>
                ))}
              </div>
              <button
                onClick={isPlaying ? stop : play}
                aria-label={isPlaying ? "Pause music" : "Play music"}
                style={{
                  background: "none",
                  border: "none",
                }}
              >
                {isPlaying ? <SoundOn /> : <SoundOff />}
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Container>
    </>
  )
}

export default Acerca
